import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { Hoverable } from '@/components/shared/redesign/Hoverable';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import { RADIUS } from '@/constants/shared/theme';

interface DesktopPanelHeaderProps {
  title: string;
  onClose: () => void;
  right?: React.ReactNode;
}

export const DesktopPanelHeader: React.FC<DesktopPanelHeaderProps> = ({ title, onClose, right }) => {
  const styles = useStyles();

  return (
    <View style={styles.header}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.right}>
        {right}
        <Hoverable hover="row" onPress={onClose} style={styles.closeButton} testID="panel-close" accessibilityRole="button" accessibilityLabel="Close">
          <Text style={styles.closeText}>✕</Text>
        </Hoverable>
      </View>
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 16,
        paddingVertical: 14,
        borderBottomWidth: 1,
        borderBottomColor: admin.dataTable.border,
        backgroundColor: 'transparent',
      },
      title: {
        fontSize: 18,
        paddingHorizontal: 18,
        fontWeight: '700',
        color: admin.dataTable.text,
      },
      right: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
      },
      closeButton: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: RADIUS.sm,
      },
      closeText: {
        fontSize: 18,
        color: colors.text.dim,
      },
    });
  });
